import React from 'react';
import Button from '../common/Button/Button';

const InvoiceControls = ({ 
  isEditable, 
  setIsEditable,
  saveInvoiceToDB, 
  downloadPDF, 
  addProduct, 
  removeProduct,
  products 
}) => {
  return (
    <div className="button-group">
      <Button className="saveinvoice-btn" onClick={saveInvoiceToDB} disabled={isEditable}> Save to Database</Button>
      {!isEditable ? (
        <Button className="btn editinvoice-btn" onClick={() => setIsEditable(true)}>Edit</Button>
      ) : (
        <Button className="save-btn" onClick={() => setIsEditable(false)}>Save</Button>
      )}
      <Button className="download-btn" onClick={downloadPDF} disabled={isEditable}>Download PDF</Button>
      <Button className="print-btn" onClick={() => window.print()} disabled={isEditable}>Print</Button>
      
      {isEditable && (
        <div className="product-controls">
          <Button onClick={addProduct}>Add Product</Button>
          {products.length > 1 && (
            <Button onClick={removeProduct}>Remove Last Product</Button>
          )}
        </div>
      )}
    </div>
  );
};

export default InvoiceControls;